<div *ngFor="let tableSection of tableSections" class="EqualColumn">
  <div *ngIf="tableSection.table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  <div class="buttonsContent mb-5" [innerHtml]="tableSection.body | mdToHtml"></div>
</div>
